document.addEventListener('DOMContentLoaded', () => {
  const thumbs = document.querySelectorAll('.product-thumbnail-container .product-thumbnail');
  const mainImages = document.querySelectorAll('.product-images__slide');
  const imagesContainer = document.querySelector('.product-images--thumbnails');

  // Forzar estado inicial: solo el primer thumb marcado
  thumbs.forEach((t, i) => {
    if (i === 0) t.classList.add('is-initial-selected');
    else t.classList.remove('is-initial-selected');
  });

  thumbs.forEach((thumb, thumbIndex) => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault();

      thumbs.forEach(t => t.classList.remove('is-initial-selected'));
      thumb.classList.add('is-initial-selected');

      const targetImage = mainImages[thumbIndex];

      if (targetImage) {
        if (window.innerWidth < 1024) {
          const container = imagesContainer || targetImage.parentNode;

          if (container) {
            container.scrollTo({
              left: targetImage.offsetLeft,
              behavior: 'smooth'
            });
          }
        } else {
          if (imagesContainer) {
            let offsetTop = 0;
            let el = targetImage;
            while (el && el !== imagesContainer) {
              offsetTop += el.offsetTop;
              el = el.offsetParent;
            }

            imagesContainer.scrollTo({
              top: offsetTop,
              behavior: 'smooth'
            });
          }
        }
      }
    });
  });

  // Scroll en contenedor de imágenes: marcar thumbnail activo
  if (imagesContainer) {
    let scrollTimeout;
    imagesContainer.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        let activeIndex = 0;

        if (window.innerWidth < 1024) {
          // Mobile: busca la imagen cuyo centro esté más cerca del centro del contenedor
          var containerCenter = imagesContainer.scrollLeft + imagesContainer.clientWidth / 2;
          var closestDist = Infinity;

          mainImages.forEach((slide, index) => {
            var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            var dist = Math.abs(slideCenter - containerCenter);
            if (dist < closestDist) {
              closestDist = dist;
              activeIndex = index;
            }
          });
        } else {
          // Desktop: scroll vertical
          var containerTop = imagesContainer.scrollTop;
          var containerHeight = imagesContainer.clientHeight;

          mainImages.forEach((slide, index) => {
            let offsetTop = 0;
            let el = slide;
            while (el && el !== imagesContainer) {
              offsetTop += el.offsetTop;
              el = el.offsetParent;
            }

            if (offsetTop <= containerTop + containerHeight * 0.5) {
              activeIndex = index;
            }
          });
        }

        if (thumbs[activeIndex]) {
          thumbs.forEach(t => t.classList.remove('is-initial-selected'));
          thumbs[activeIndex].classList.add('is-initial-selected');
        }
      }, 10);
    });
  }
});